var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335.5 507.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#895d45;}.cls-2{fill:#00b738;}.cls-3{fill:#930090;}.cls-4{fill:#b500b1;}.cls-5{fill:#d90039;}.cls-6{fill:#f7004d;}.cls-7{fill:#009e2d;}.cls-8{fill:#439ab5;}.cls-9{fill:#59c7ff;}.cls-10{fill:#a97554;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34 272.8 151 35.8 317.76 251.13 222 403.5 190.73 448.07 156.79 413.19 34 272.8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295,147",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295.23,147.1c-3.11,30.24-6.5,60.42-9.85,90.6-1.6,15.09-3.39,30.16-4.94,45.26s-3.28,30.17-4.72,45.27-3,30.18-4.32,45.28c-.72,7.55-1.31,15.11-1.94,22.66s-1.14,15.11-1.64,22.67l-.38,5.67-.31,5.67c-.2,3.78-.43,7.57-.59,11.35s-.39,7.57-.48,11.35-.22,7.57-.27,11.35-.1,7.57-.06,11.35l.12,5.68c0,1.89.06,3.78.19,5.67l.3,5.67.08,1.42.15,1.4.29,2.83.28,2.82c.05.48.09.95.15,1.42l.24,1.4,1,5.61L267,504l-.37-1.38c-.11-.47-.19-.94-.28-1.4l-.54-2.81-.53-2.81-.25-1.41-.19-1.42-.75-5.67c-.27-1.9-.44-3.79-.59-5.69l-.49-5.7c-.29-3.81-.44-7.61-.66-11.42-.59-15.24-.48-30.49,0-45.7.93-30.45,3.41-60.79,6.39-91.06q2.36-22.68,5.12-45.32c1.93-15.08,3.86-30.16,6.1-45.19C284.36,206.93,289.26,176.92,295.23,147.1Z",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 291.31,
    cy: 116.1,
    rx: 52.01,
    ry: 86.9,
    transform: "translate(-86.58 -25.17) rotate(-0.79)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 289.8,
    cy: 205.86,
    rx: 8,
    ry: 8.5,
    transform: "translate(-109.77 11.11) rotate(-7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M221.42,75.79s83.43,64.53,71.09,127.2C292.51,203,230.5,218.85,221.42,75.79Z",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M361,30s-100.7,90.65-71.27,173.47C289.73,203.47,377.47,226.55,361,30Z",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.91,239.52",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.77,245.59c7.82,20.86,14.74,42,21.26,63.31,3.31,10.63,6.35,21.34,9.42,32s5.87,21.48,8.69,32.25,5.37,21.62,7.83,32.49,4.79,21.76,6.73,32.75,3.78,22,5.08,33.1c.58,5.56,1.12,11.12,1.35,16.71a105.23,105.23,0,0,1-.41,16.75c-.14-2.8-.16-5.56-.52-8.32-.21-2.76-.62-5.51-1-8.25s-.88-5.47-1.3-8.2-1-5.45-1.52-8.17c-1.06-5.44-2.16-10.87-3.37-16.28s-2.37-10.83-3.65-16.22l-3.85-16.19c-1.32-5.39-2.61-10.78-4-16.16q-4-16.15-8.16-32.28c-2.68-10.77-5.51-21.51-8.29-32.26s-5.59-21.5-8.28-32.29C217.27,288.84,211.82,267.29,206.77,245.59Z",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 199.63,
    cy: 216.38,
    rx: 38.19,
    ry: 63.82,
    transform: "translate(-130.52 24.16) rotate(-13.68)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 217.17,
    cy: 279.92,
    rx: 5.87,
    ry: 6.24,
    transform: "translate(-116.8 -1.34) rotate(-6.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M241.92,174.89s-47.47,61.2-27.19,103.49C214.73,278.38,261.72,278.28,241.92,174.89Z",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M132,166s90.51,47.92,84.79,112.21C216.79,278.21,156.36,308.78,132,166Z",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M264,501,420.5,184.5C307.5,275.5,264,501,264,501Z",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M85,181,267,505S218.43,274.05,85,181Z",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M320,244.16",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M328.13,250.23c-5.05,21.71-10.51,43.26-16,64.79-2.69,10.79-5.59,21.51-8.29,32.29s-5.61,21.49-8.28,32.26-5.52,21.51-8.16,32.28c-1.38,5.38-2.68,10.77-4,16.16l-3.84,16.18c-1.29,5.4-2.46,10.82-3.66,16.23s-2.31,10.84-3.37,16.28c-.5,2.72-1.06,5.44-1.52,8.17s-.93,5.46-1.3,8.2-.79,5.49-1,8.25c-.36,2.76-.38,5.52-.53,8.31a106.26,106.26,0,0,1-.41-16.74c.23-5.59.78-11.15,1.36-16.71,1.3-11.1,3-22.13,5.07-33.1s4.36-21.87,6.74-32.76,5.13-21.68,7.83-32.48,5.68-21.53,8.68-32.25,6.11-21.41,9.43-32C313.38,292.27,320.31,271.1,328.13,250.23Z",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 335.27,
    cy: 221.03,
    rx: 63.82,
    ry: 38.19,
    transform: "translate(-43.8 465.29) rotate(-76.32)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 317.72,
    cy: 284.57,
    rx: 6.24,
    ry: 5.87,
    transform: "translate(-87.67 536.93) rotate(-83.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M293,179.54s47.48,61.19,27.2,103.49C320.17,283,273.17,282.93,293,179.54Z",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M403.08,162.61s-90.7,56-85,120.25C318.11,282.86,378.72,305.39,403.08,162.61Z",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M275.73,537l-30.06-351.8C196.14,321.53,275.73,537,275.73,537Z",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M275.73,537S312,393,119,302Z",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M275.13,532.28S222,393.67,402.76,280.33Z",
    transform: "translate(-85 -29.2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "190.73 507.75 198.68 503.08 235.66 413.19 194.62 427.99 190.73 507.75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowers);
export default __webpack_public_path__ + "static/media/flowers.1d934dbe.svg";
export { ForwardRef as ReactComponent };